const teamList = [
  {
    id: "1",
    name: "Clifford Kennedy",
    title: "CEO & CO-FOUNDER",
    img: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=facearea&facepad=2.2&w=300&h=300&q=144",
    desc: "team-member-01",
  },
  {
    id: "2",
    name: "Clifford Kennedy",
    title: "CEO & CO-FOUNDER",
    img: "https://images.unsplash.com/photo-1609010697446-11f2155278f0?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2.2&w=300&h=300&q=144",
    desc: "team-member-02",
  },
  {
    id: "3",
    name: "Clifford Kennedy",
    title: "CEO & CO-FOUNDER",
    img: "https://images.unsplash.com/photo-1603415526960-f7e0328c63b1?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2.2&w=300&h=300&q=144",
    desc: "team-member-03",
  },
  {
    id: "4",
    name: "Clifford Kennedy",
    title: "CEO & CO-FOUNDER",
    img: "https://images.unsplash.com/photo-1607990281513-2c110a25bd8c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=facearea&facepad=2.2&w=300&h=300&q=144",
    desc: "team-member-04",
  },
  {
    id: "5",
    name: "Clifford Kennedy",
    title: "CEO & CO-FOUNDER",
    img: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2.2&w=300&h=300&q=144",
    desc: "team-member-05",
  },
  {
    id: "6",
    name: "Clifford Kennedy",
    title: "CEO & CO-FOUNDER",
    img: "https://images.unsplash.com/photo-1541647376583-8934aaf3448a?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&&fit=facearea&facepad=2.2&w=300&h=300&q=144",
    desc: "team-member-06",
  },
];

export default teamList;
